import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personnel-relieving-form',
  templateUrl: './personnel-relieving-form.component.html',
  styleUrls: ['./personnel-relieving-form.component.css']
})
export class PersonnelRelievingFormComponent implements OnInit {
  title="Personnel Relieving";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/personnel-details/Personnel-Relievings/personnel-relieving-form/personnel-relieving-form.component.ts